/* eslint-disable */
import Vue from 'vue'
import config from '../config/'

class Analysis {
  constructor (cnzzId) {
    if (cnzzId) {
      this.cnzzId = cnzzId
      this.init()
    }
  }
  init () {
    window._czc = window._czc || []
    this._insertDeclear()
    this._insertScript()
  }
  _insertScript () {
    let head = document.getElementsByTagName('head')[0]
    let scriptNode = document.createElement('script')
    scriptNode.type = 'text/javascript'
    scriptNode.src = (window.location.protocol === 'https:' ? 'https:' : 'http:') + '//s95.cnzz.com/z_stat.php?id=' + this.cnzzId + '&web_id=' + this.cnzzId
    head.appendChild(scriptNode)
  }
  _insertDeclear () {
    let head = document.getElementsByTagName('head')[0]
    let scriptNode = document.createElement('script')
    let declear = `var _czc = _czc || []; _czc.push('setAccount', ${this.cnzzId})`
    let textNode = document.createTextNode(declear)
    scriptNode.appendChild(textNode)
    head.appendChild(scriptNode)
  }
  trackEvent (category, action, label, value) {
    try {
      _czc.push(['_trackEvent', category, action, label, value])
    } catch (e) {}
  }
}

let getInstance = (ConstructorFn) => {
  let instance
  return (cnzzId) => {
    return instance || (instance = new ConstructorFn(cnzzId))
  }
}

let instance = getInstance(Analysis)(config.cnzzId)
Vue.$analysis = Vue.prototype.$analysis = instance